var swal = require('sweetalert2');

module.exports = function () {
    $(document).ready(function (event) {

        // Yeah I know, three files are very similar. It should be refactored.

        var helper = require('./helper');
        var AjaxController = require('./services/AjaxController');

        let oldValue;

        $(document)
            .on('focus', '.js-client-update-field-text', function(e){
                oldValue = $(this).val();
            })
            .on('change', '.js-client-update-field-text', function(e){

            var $this = $(this);
            var id = $this.data('id'),
                field = $this.data('field'),
                value = $this.val();
            var url = '/api/clients/update-field';

            var data = {
                field: field,
                id: id,
                value: value
            };

            var success = function (response) {
                console.log('Success');
            };
            var error = function (response) {
                console.log('Error');
            };

            e.preventDefault();

            swal({
                title: "Are you sure you want to save changes?",
                text: "",
                type: "warning",
                showCancelButton: true
            }).
            then(function (result) {
                if (result.value) {
                    AjaxController.prototype.send(url, data, success, error);
                    $("#edited-internalinfo").load(location.href + " #edited-internalinfo>*", "");

                    oldValue = $(".js-client-update-field-text").val();
                } else {
                    $(".js-client-update-field-text").val(oldValue);
                }
            })
        });
    });
}();
